import dayjs from 'dayjs';

export default function({ startedAt, check_in_duration }) {
    /**
     * Formats a date taking into account the CHILL Check-in time
     * @param {Object} {startedAt, check_in_duration}
     * @return {String}
     */
    if (!startedAt) {
        return null;
    }

    return dayjs(startedAt)
        .add(check_in_duration, 'second')
        .format('MM/DD/YYYY hh:mm A');
}
